import { boolean, object } from 'yup';

import { FormSection } from '@@/form-components/FormSection';
import { SwitchField } from '@@/form-components/SwitchField';

export type DeployerOptions = {
  Prune: boolean;
  RemoveVolumes: boolean;
};

export type DeployerOptionsFormValues = {
  Prune: boolean;
  RemoveVolumes: boolean;
  KubernetesPrune: boolean;
  KubernetesForceApply: boolean;
};

export type DeployerOptionsPayload = {
  Prune: boolean;
  RemoveVolumes: boolean;
  KubernetesPrune: boolean;
  KubernetesForceApply: boolean;
};

/** Shared so the create and edit forms cannot drift apart on the defaults. */
export function deployerOptionsValidation() {
  return object({
    Prune: boolean().default(false),
    RemoveVolumes: boolean().default(false),
    KubernetesPrune: boolean().default(true),
    KubernetesForceApply: boolean().default(false),
  });
}

type OnValueChangeProps<T> = {
  value: T;
  onChange: (value: T) => void;
};

export const defaultDeployerOptionsFormValues: DeployerOptionsFormValues = {
  Prune: false,
  RemoveVolumes: false,
  // Pruning is on by default.
  KubernetesPrune: true,
  KubernetesForceApply: false,
};

type Props = {
  values: DeployerOptionsFormValues;
  onChange: (value: Partial<DeployerOptionsFormValues>) => void;
};

export function DeployerOptionsFieldset({ values, onChange }: Props) {
  return (
    <FormSection title="Deployer options">
      <DeployerOptionsFields values={values} onChange={onChange} />
    </FormSection>
  );
}

export function DeployerOptionsFields({ values, onChange }: Props) {
  return (
    <>
      <PruneField
        value={values.Prune}
        onChange={(Prune) => onChange({ Prune })}
      />
      <RemoveVolumesField
        value={values.RemoveVolumes}
        onChange={(RemoveVolumes) => onChange({ RemoveVolumes })}
      />
    </>
  );
}

function PruneField({ value, onChange }: OnValueChangeProps<boolean>) {
  return (
    <div className="form-group">
      <div className="col-sm-12">
        <SwitchField
          checked={value}
          data-cy="edge-stack-deployer-option-prune"
          name="deployerOptionsPrune"
          label="Prune services"
          tooltip="When enabled, prune services that are no longer referenced in the stack file"
          labelClass="col-sm-3 col-lg-2"
          onChange={onChange}
        />
      </div>
    </div>
  );
}

function RemoveVolumesField({ value, onChange }: OnValueChangeProps<boolean>) {
  return (
    <div className="form-group">
      <div className="col-sm-12">
        <SwitchField
          checked={value}
          data-cy="edge-stack-deployer-option-remove-volumes"
          name="deployerOptionsRemoveVolumes"
          label="Remove volumes"
          tooltip="When enabled, remove volumes associated with services when the stack is removed"
          labelClass="col-sm-3 col-lg-2"
          onChange={onChange}
        />
      </div>
    </div>
  );
}
